import React, { useState, useEffect } from 'react';
import { Container, Row, Col, InputGroup } from 'react-bootstrap';
import { axiosInstance } from '../../../../../api/axios';
import { HttpSuccessCodes } from '../../../../errorhandling/HttpErrorCodes';
import FilterModal from '../../../../components/common/filter-modal/FilterModal';
import { SearchSVG } from '../../../../img/GlobalSVG';
import TextInput from '../../../../../Components/GenericInputText/TextInput';
import APIEndpoints from '../../../../api/APIEndpoints';
import Lists from '../lists';
import Skeleton from 'src/Member/components/footer/Skeleton';

const LocationPanel = ({
  blkOfBusOid,
  clientOid,
  onSelectedLocationHandler,
  locationAllData,
  setLocationAllData,
  selectedLocationData,
  editAffiliatedRecords,
}) => {
  const cacheBuster = (url) => `${url}?cb=${Date.now()}`;

  const [openLocationModal, setOpenLocationModal] = useState(false);
  const [locationData, setLocationData] = useState([]);
  const [searchString, setSearchString] = useState('');
  const [loadingPage, setLoadingPage] = useState(true);
  const [customError, setCustomError] = useState(false);
  const [searched, setSearched] = useState([]);
  const [searchedData, setSearchedData] = useState([]);
  let flag = false;

  const onChangeLocationHandler = (e) => {
    setSearchString(e.target.value);
    const tempLocation2 = locationData.filter(
      (location) =>
        location?.LocationName?.toLowerCase().includes(
          e.target.value.toLowerCase(),
        ) ||
        location?.oid?.toLowerCase().includes(e.target.value.toLowerCase()),
    );
    setSearchedData(tempLocation2);
    tempLocation2.map((location) => {
      if (location.isChecked === true) {
        return;
      } else {
        flag = true;
      }
    });
    if (!flag) {
      setSearched(tempLocation2);
    } else {
      setSearched([]);
    }
  };

  const handleAddLocation = (e, blkOfBusOid, clientOid) => {
    e.stopPropagation();
    setOpenLocationModal(true);
    setLocationData([]);
    getLocationData(clientOid);
    setSearched([]);
  };

  const applyFilterHandler = () => {
    if (locationData && locationData.length > 0) {
      const locationAllObj = { [locationData[0].ClientOid]: locationData };
      let tempObj = { ...locationAllData };
      tempObj = Object.assign(tempObj, locationAllObj);
      setLocationAllData(tempObj);
    }
    const selectedlocation = locationData.filter(
      (location) => location.isChecked == true,
    );
    onSelectedLocationHandler(selectedlocation, blkOfBusOid, clientOid);
    setOpenLocationModal(false);
    setSearchString('');
  };

  const selectChangeHandler = (e) => {
    e.stopPropagation();
    const { name, checked } = e.target;
    if (name === 'select-all-location') {
      if (searchString === '') {
        const tempLocation = locationData.map((location) => {
          return { ...location, isChecked: checked };
        });
        setLocationData(tempLocation);
      } else {
        const tempLocation = locationData.map((location) =>
          location?.oid?.toLowerCase().includes(searchString.toLowerCase()) ||
          location?.LocationName?.toLowerCase().includes(
            searchString.toLowerCase(),
          )
            ? { ...location, isChecked: checked }
            : location,
        );
        const data = tempLocation.filter(
          (location) => location.isChecked === true,
        );
        setSearched(data);
        setLocationData(tempLocation);
      }
    } else {
      if (searchString === '') {
        const tempLocation = locationData.map((location) =>
          location.oid === name
            ? { ...location, isChecked: checked }
            : location,
        );
        setLocationData(tempLocation);
      } else {
        const tempLocation2 = locationData.map((location) =>
          location?.oid?.toLowerCase().includes(searchString.toLowerCase()) ||
          location?.LocationName?.toLowerCase().includes(
            searchString.toLowerCase(),
          )
            ? location.oid === name
              ? { ...location, isChecked: checked }
              : location
            : location,
        );
        const tempLocation = tempLocation2.filter(
          (location) =>
            location?.oid?.toLowerCase().includes(searchString.toLowerCase()) ||
            location?.LocationName?.toLowerCase().includes(
              searchString.toLowerCase(),
            ),
        );
        //const tempBlob1 = tempBlob.map( blob => blob.BlkOfBusId === name ? { ...blob, isChecked: checked } : blob );
        tempLocation.map((location) => {
          if (location.isChecked === true) {
            return;
          } else {
            flag = true;
          }
        });
        if (!flag) {
          setSearched(tempLocation);
        } else {
          setSearched([]);
        }
        setLocationData(tempLocation2);
      }
    }
  };

  const getLocationData = async (clientOid) => {
    try {
      const locationSelectedData = [locationAllData]
        .map((item) => item[clientOid] || null)
        .filter((e1) => e1 !== null)
        .map((ele) => ele.map((lcn) => lcn))
        .filter((el) => el !== null);
      console.log(
        'locationSelectedData :::::::::::::  ',
        locationSelectedData,
        locationSelectedData[0],
      );
      if (locationSelectedData.length > 0) {
        setLoadingPage(false);
        setCustomError(false);
        setLocationData(locationSelectedData[0]);
      } else {
        const LocationListResponse = await axiosInstance.get(
          cacheBuster(
            APIEndpoints.getLocationListResources() + 'clientoid/' + clientOid,
          ),
        );
        if (
          LocationListResponse.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200
        ) {
          setLoadingPage(false);
          setCustomError(false);
          console.log(
            'LocationListResponse :::: $$$$$ ::::: ',
            LocationListResponse?.data?.Response?.Location,
          );
          //setBlobData(tempBlob);

          if (LocationListResponse?.data?.Response?.Location) {
            if (
              selectedLocationData &&
              selectedLocationData[clientOid] &&
              selectedLocationData[clientOid].length > 0
            ) {
              const locationList =
                LocationListResponse?.data?.Response?.Location;
              const tempObj = locationList.map((item) =>
                selectedLocationData[clientOid].filter((selectedItem) =>
                  Boolean(selectedItem.oid === item.oid),
                ).length
                  ? { ...item, isChecked: true }
                  : item,
              );
              setLocationData(tempObj);
            } else if (
              selectedLocationData &&
              !selectedLocationData[clientOid] &&
              selectedLocationData.length > 0
            ) {
              const locationList =
                LocationListResponse?.data?.Response?.Location;
              const tempObj = locationList.map((item) =>
                selectedLocationData.filter((selectedItem) =>
                  Boolean(selectedItem.oid === item.oid),
                ).length
                  ? { ...item, isChecked: true }
                  : item,
              );
              setLocationData(tempObj);
            } else {
              setLocationData(LocationListResponse?.data?.Response?.Location);
            }
          }
        }
      }
    } catch (error) {
      setLoadingPage(false);
      setCustomError(true);
      setLocationData([]);
    }
  };

  return (
    <>
      {editAffiliatedRecords ? (
        <button
          type="button"
          className="panel-card-link"
          onClick={(e) => handleAddLocation(e, blkOfBusOid, clientOid)}
        >
          Select Locations(s)
        </button>
      ) : (
        <button
          type="button"
          className="panel-card-link panel-card-link-disable"
        >
          Select Locations(s)
        </button>
      )}
      <FilterModal
        showBackButton={false}
        isVisible={openLocationModal}
        onHide={() => {
          setSearchString('');
          setOpenLocationModal(false);
          setCustomError(false);
          //setLoadingPage( true );
        }}
        applyFilterHandler={applyFilterHandler}
        showCancel={true}
        titleLabel="Location(s)"
        showApply={true}
        showApplyLabel="Add Selected"
      >
        {loadingPage && !customError && <Skeleton count={10} />}
        {!loadingPage &&
          !customError &&
          locationData &&
          Object.keys(locationData).length > 0 && (
            <Container className="mt-3 mb-3">
              <Row>
                <Col sm={12}>
                  <div>
                    <TextInput
                      parentClassName="mb-2"
                      label="Location"
                      append={
                        <InputGroup.Text>
                          <SearchSVG.SearchSVG className="primary-text-color" />
                        </InputGroup.Text>
                      }
                      inputProps={{
                        type: 'text',
                        placeholder: 'Search by name or description',
                        value: searchString,
                        onChange: onChangeLocationHandler,
                        className: 'border-right-0',
                        autoFocus: false,
                        id: 'filter-broker-input',
                      }}
                    />
                  </div>
                </Col>
              </Row>
              {searchString === '' ? (
                <>
                  <Row>
                    <Col sm={12} className="mt-4 mb-2">
                      <div className=" select-all-row d-flex">
                        <input
                          type="checkbox"
                          id="select-all-location"
                          name="select-all-location"
                          className="p-0 mt-auto mb-auto"
                          onChange={(e) => {
                            selectChangeHandler(e);
                          }}
                          checked={
                            searchString === ''
                              ? locationData.filter(
                                  (location) => location.isChecked !== true,
                                ).length < 1
                              : searched && searched.length
                              ? searched.filter((emp) => emp.isChecked !== true)
                                  .length < 1
                              : locationData.filter(
                                  (location) => location.isChecked !== true,
                                ).length < 1
                          }
                        />
                        <label
                          className="my-auto select-all-checkbox"
                          htmlFor="select-all-location"
                        >
                          Select All
                        </label>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12} className="mb-1">
                      {
                        <Lists
                          data={locationData}
                          selectChangeHandler={selectChangeHandler}
                          displayId="oid"
                          displayLabel="LocationName"
                          labelIdText=""
                          searchString={searchString}
                        />
                      }
                    </Col>
                  </Row>
                </>
              ) : (
                <>
                  {searchedData && Object.keys(searchedData).length ? (
                    <>
                      <Row>
                        <Col sm={12} className="mt-4 mb-2">
                          <div className=" select-all-row d-flex">
                            <input
                              type="checkbox"
                              id="select-all-location"
                              name="select-all-location"
                              className="p-0 mt-auto mb-auto"
                              onChange={(e) => {
                                selectChangeHandler(e);
                              }}
                              checked={
                                searchString === ''
                                  ? locationData.filter(
                                      (location) => location.isChecked !== true,
                                    ).length < 1
                                  : searched && searched.length
                                  ? searched.filter(
                                      (emp) => emp.isChecked !== true,
                                    ).length < 1
                                  : locationData.filter(
                                      (location) => location.isChecked !== true,
                                    ).length < 1
                              }
                            />
                            <label
                              className="my-auto select-all-checkbox"
                              htmlFor="select-all-location"
                            >
                              Select All
                            </label>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={12} className="mb-1">
                          {
                            <Lists
                              data={locationData}
                              selectChangeHandler={selectChangeHandler}
                              displayId="oid"
                              displayLabel="LocationName"
                              labelIdText=""
                              searchString={searchString}
                            />
                          }
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <Container className="mt-3 mb-3">
                      <div>No Records Found</div>
                    </Container>
                  )}
                </>
              )}
            </Container>
          )}

        {!loadingPage &&
          customError &&
          locationData &&
          Object.keys(locationData).length == 0 && (
            <Container className="mt-3 mb-3">
              <div>No Records Found</div>
            </Container>
          )}
      </FilterModal>
    </>
  );
};

export default LocationPanel;
